module.exports = __webpack_public_path__ + "static/img/wajue.23ecd1e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wajue.gif
// module id = at7O
// module chunks = 1